import React, { useEffect } from 'react'
import '../../css/common.css'
import { DataGrid } from '@mui/x-data-grid'
import { useState } from 'react';
import SearchBar from '../../common/searchBar/SearchBar';
import BreadCrumbBar from '../../common/breadCrumbBar/BreadCrumbBar';
import ExportExcel from '../../common/excel/ExportExcel';
import moment from 'moment';
import { ApiService } from '../../services/apiService';
import { CircularProgress } from '@mui/material';
import RemoveCircleRoundedIcon from '@mui/icons-material/RemoveCircleRounded';
import { useSelector } from 'react-redux';
import Warning from '../../common/alert/Warning';
import { dateFormat } from '../../common';
import Delete from '../../common/alert/Delete';
import UserDeviceForm from './UserDeviceForm';


export default function UserList() {
	const [rowData, setRowData] = useState([]);
	let params = "";
	const scroll = 'paper';
	const [containData, setContainData] = useState({});
	const [rowCount, setRowCount] = useState(0);
	const [alertOpen, setAlertOpen] = useState(false);
	const [openWarning, setOpenWarning] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');
	const [deviceDataOpen, setDeviceDataOpen] = useState(false);
	const [clickItem, setClickItem] = useState('');
	const [excelClick, setExcelClick] = useState(false);
	const [excelList, setExcelList] = useState([]);
	const [totalLength, setTotalLength] = useState(0);
	const [loading, setLoading] = useState(false);
	const [alertLoading, setAlertLoading] = useState(false);
	const [userData, setUserData] = useState([]);
	const [deviceData, setDeviceData] = useState([]);
	const authData = useSelector(state => state.auth);
	const role = authData.user.role.includes("users");
	const xlsxHeader = {
		header: [
			'이메일', '닉네임', '단말 갯수', 'OS 종류', 'OS 버전', 'App 버전', '가입일자', 'SNS'
		]
	}
	const [paginationModel, setPaginationModel] = useState({
		page: 0,
		pageSize: 30,
	});
	
	const handleKeyUp = (e) => {
		if(e.key === "PrintScreen") {
			var inpFld = document.createElement("input");
            inpFld.setAttribute("value", ".");
            inpFld.setAttribute("width", "0");
            inpFld.style.height = "0px";
            inpFld.style.width = "0px";
            inpFld.style.border = "0px";
            document.body.appendChild(inpFld);
            inpFld.select();
			navigator.clipboard.writeText(`${inpFld}`)
			.then(()=>{
				setOpenWarning(true);
				setErrorMsg('해당 화면은 캡처할 수 없습니다!');
			})
			.catch((error)=> {
				console.log('error', error)
			})
            // document.execCommand("copy");
            inpFld.remove(inpFld);
		}
	}
	
	React.useEffect(() => {
		document.addEventListener('keyup', handleKeyUp)

		return () => {
			document.removeEventListener('keyup', handleKeyUp)
		}
	}, []);

	const closeWarning = (data) => {
		setOpenWarning(data);
	}

	const today = moment().format('YYYY-MM-DD');
	const xlsxFileName = "사용자리스트" + today;

	const getExcelData = async () => {
    setExcelClick(false);
    setLoading(true);
    params = `limit=${totalLength}`;

		try {
			const response = await ApiService.getUserList(params);
			const excelRows = response.data.datas.map((data) => {
        data.created = dateFormat(new Date(data.created));
        data.deviceCount = data.devices.length + "개";

        if (data.ostype === 0) {
          data.ostype = "Android";
        } else if (data.ostype === 1) {
          data.ostype = "iOS";
        } else {
          data.ostype = "undefined";
        }

        var replaceAt = (input, index, character) => {
          return (
            input.substr(0, index) +
            character +
            input.substr(index + character.length)
          );
        };

        // data.id = replaceAt(data.id, 0, "**");

        return {
          이메일: data.id,
          닉네임: data.name,
          "단말 갯수": data.deviceCount,
          "OS 종류": data.ostype,
          "OS 버전": data.osver,
          "App 버전": data.appver,
          가입일자: data.created,
          SNS: data.snstype,
        };
      });
			setExcelClick(true);
      setExcelList(excelRows);
		} catch(error) {
			console.log("UserList - getExcelData - error :: ", error);
		} finally {
			setLoading(false);
		}
  };

	const columns = [
		{
			field: 'id',
			headerName: '이메일',
			minWidth: 340,
			flex: 1,
			// width: 360,
		},
		{
			field: 'name',
			headerName: '닉네임',
			minWidth: 100,
			flex: 1,
			// width: 130,
		},
		{
			field: 'deviceCount',
			headerName: '단말 갯수',
			minWidth: 60,
			flex: 0.7,
			renderCell: (params) => {
				// you will find row info in params
				return(
					<>
						<p onClick={() => alertDeviceData(params.row.id, params.row.devices)} style={{cursor:"pointer"}}>{params.value}</p>
					</>
				)
			}
		},
		{
			field: 'ostype',
			headerName: 'OS 종류',
			minWidth: 90,
			flex: 0.7,
		},
		{
			field: 'osver',
			headerName: 'OS 버전',
			// width: 120,
			minWidth: 80,
			flex: 0.7,
		},
		{
			field: 'appver',
			headerName: 'App 버전',
			// width: 120,
			minWidth: 80,
			flex: 0.7,
		},
		{
			field: 'created',
			headerName: '가입일자',
			minWidth: 150,
			flex: 1,
		},
		{
			field: 'snstype',
			headerName: 'SNS',
			// width: 110,
			minWidth: 60,
			flex: 0.6,
		},
		{
			field: 'delete',
			headerName: '삭제',
			flex: 0.5,
			minWidth: 100,
			renderCell: (params) => {
				// you will find row info in params
				return(
					<>
						<button className="deleteBtn" onClick={() => alertOpenHandle(params.row.id)}><RemoveCircleRoundedIcon sx={{pr:1, verticalAlign: "-1px", fontSize: "15px"}}/>삭제</button>
					</>
				)
			}
		},
	];

	const alertOpenHandle = (id) => {
		setAlertOpen(true);
		setClickItem(id);
	}

	const alertCloseHandle = () => {
		setAlertOpen(false);
		setClickItem('');
	}

	const alertDeviceData = async (userId, devices) => {
		setDeviceDataOpen(true);
		params = `contains=${JSON.stringify({ "id" : userId })}`;

		try {
			setAlertLoading(true);
			const userList = await ApiService.getUserList(params);
			setUserData(userList.data.datas);
		} catch(error) {
			console.log('UserList - alertDeviceData - error ::', error)
			// setOpenWarning(true);
			// setErrorMsg(error.response.data.message);
		} finally {
			getDeviceDataList(devices);
			setAlertLoading(false);
		}
	}

	const getDeviceDataList = async (devices) => {

		let deviceItem = [];

		for (const deviceId of devices) {
			params = `contains=${JSON.stringify({ "id" : deviceId })}`;
			try {
				const deviceList = await ApiService.getDeviceList(params);
				deviceItem.push(deviceList.data.datas);
			} catch(error) {
				console.log('UserList - getDeviceDataList - error ::', error)
			} finally {
				setAlertLoading(false);
				setDeviceData(() => (deviceItem));
			}
		}
	}

	const alertDeviceCloseHandle = () => {
		setDeviceDataOpen(false);
		setDeviceData([]);
	}

	const options = [
		{ 
			value: 'none',
			item: '검색할 항목 선택',
		},
		{
			value: 'id',
			item: '이메일',
		},
		{ 
			value: 'created',
			item: '가입일자',
		},
	];

	const getUserList = async (limit, page, containData, startTime, endTime) => {
		if (startTime !== null && endTime !== null) {
			params = `limit=${limit}&offset=${limit*page}&stime=${startTime}&etime=${endTime}`;
		} else {
			params = `limit=${limit}&offset=${limit*page}&contains=${JSON.stringify(containData)}`;
		}

		try {
			setLoading(true);
			const userList = await ApiService.getUserList(params);

			if(JSON.stringify(containData) === '{}' && (startTime === null && endTime === null)) {
				setTotalLength(userList.data.total);
			}
			const rows = userList.data.datas.map((data) => {
				data.created = dateFormat(new Date(data.created))
				data.deviceCount = data.devices.length + '개';

				if (data.ostype === 0) {
					data.ostype = "Android";
				} else if (data.ostype === 1) {
					data.ostype = "iOS";
				} else {
					data.ostype = "undefined";
				}
				return data;
			})

			setRowData(rows);
			setRowCount(userList.data.total);
		} catch(error) {
			console.log('UserList - getUserList - error ::', error)
			// setOpenWarning(true);
			// setErrorMsg(error.response.data.message);
		} finally {
			setLoading(false);
		}
	}

	useEffect(() => {
		//등록일자 검색할 경우
		if(containData["created"]) {
			//let timestampSecond = Math.floor(+ new Date("2022-10-23") / 1000)
			let startTime = Math.floor(new Date(containData["created"] + " 00:00:00") / 1000);
			let endTime = Math.floor(new Date(containData["created"] + " 23:59:59") / 1000);
			getUserList(paginationModel.pageSize, paginationModel.page, containData, startTime, endTime);
		} else {
			getUserList(paginationModel.pageSize, paginationModel.page, containData, null, null);
		}

	}, [paginationModel.page, containData]);

	const handleDelete = async () => {
		try {
			await ApiService.deleteUser(clickItem);
			alertCloseHandle();
		} catch (error) {
			console.log('AdminList - handleEditPw - error :: ', error)
			setOpenWarning(true);
			setErrorMsg(error.response.data.message);
		} finally {
			getUserList(paginationModel.pageSize, paginationModel.page, containData, null, null);
		}
	}

	const getData = (selectValue, inputValue) => {
		if ((selectValue === "none") && (inputValue !== "")) {
			alert('검색할 항목을 선택하세요!')
		} else {
			if(inputValue === "") {
				setContainData({})
			} else {
				if(selectValue === "ostype") {
					if(inputValue.trim().toLowerCase() === "android") {
						inputValue = 0;
					} else {
						inputValue = 1;
					}
					setContainData({ [selectValue]: inputValue })
				} else {
					setContainData({ [selectValue]: inputValue.trim() })
				}
			}
		} 
	}

	return (
    <div className="containList">
      {role !== true ? (
        <Warning
          open={openWarning}
          onHideWarning={closeWarning}
          warningMsg={"해당 메뉴에 대한 권한이 없습니다!"}
        ></Warning>
      ) : (
        <>
          <BreadCrumbBar menu="사용자 관리" smenu="사용자 정보 조회" />
          <div className="containItem">
            <div className="excelBtn" onClick={getExcelData}>
              <div style={{display: "none"}}>
                <ExportExcel
                  excelClick={excelClick}
                  header={xlsxHeader}
                  excelData={excelList}
                  fileName={xlsxFileName}
                />
              </div>
            </div>
            <SearchBar options={options} getData={getData} />
          </div>
          <div className="gridItem">
            {loading && (
              <CircularProgress
                sx={{ position: "absolute", top: "50%", left: "50%" }}
              />
            )}
            <DataGrid
              sx={{
                ".MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "bold",
                },
              }}
              rows={rowData}
              columns={columns}
              columnHeaderHeight={35}
              rowHeight={23}
              autoHeight={true}
              paginationMode="server"
              pageSizeOptions={[paginationModel.pageSize]}
              rowCount={rowCount}
              onPaginationModelChange={setPaginationModel}
              paginationModel={paginationModel}
              disableColumnMenu={true}
              disableSelectionOnClick
            />
          </div>

          {alertLoading ? (
            <CircularProgress
              sx={{ position: "absolute", top: "50%", left: "50%" }}
            />
          ) : (
            <UserDeviceForm
              deviceDataOpen={deviceDataOpen}
              deviceDataClose={alertDeviceCloseHandle}
              userData={userData}
              deviceData={deviceData}
            />
          )}

          <Warning
            open={openWarning}
            onHideWarning={closeWarning}
            warningMsg={errorMsg}
          ></Warning>

          <Delete
            openDelete={alertOpen}
            closeDelete={alertCloseHandle}
            onClickDelete={handleDelete}
          />
        </>
      )}
    </div>
  );
}


